const QuotationBody = () => {
  return (
    <section>
      <div>
        
      </div>
    </section>
  );
};

export default QuotationBody;
